import React, { useState } from 'react'
import style from './Navbar.module.css';
import Logo from '../../../assets/AssetHouseLogo.png';
import {Link} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import {logout} from '../../../redux/actions/authActions';
import {Avatar} from 'antd';
import Male from '../../../assets/Avatars/male.png';
import Female from '../../../assets/Avatars/female.png';
import {AiFillCaretDown} from 'react-icons/ai';
import 'bootstrap/dist/js/bootstrap.bundle';

const Navbar = () => {
    const auth = useSelector(state => state.auth);
    const user = useSelector(state => state.user);
    const [menu, setMenu] = useState(false)
    const dispatch = useDispatch();

    const logoutUser = (e) => {
        dispatch(logout(e));
    }

    const toggleMenu = (e) => {
        if(menu){
            setMenu(false)
        }else{
            setMenu(true)
        }
    }

    return (
        <nav className={`${style.navbar} container`}>
        <div className={style.navbarLeft}>
            <div className={style.logoContainer}>
                <img src={Logo} alt="logo" style={{
                    width: "2.5rem", height: "2.5rem"
                }}/>
                <strong className="mx-1">
                    <Link style={{textDecoration: "none", color: "black"}} to='/'>
                        Asset House
                    </Link>
                </strong>
            </div>
        </div>
        <div className={style.navbarRight}>
            <ul>
                <li>
                    <Link to='/'>
                        <strong>Home</strong>
                    </Link>
                </li>
                <li>
                    <Link to='/'>
                        <strong>Pricing</strong>
                    </Link>
                </li>
                <li>
                    <Link to='/'>
                        <strong>Features</strong>
                    </Link>
                </li>
                {
                    !auth.isAuthenticated 
                    ? (
                        <>
                            <li>
                                <Link to='/login'>
                                    <strong>Login</strong>
                                </Link>
                            </li>
                            <li>
                                <Link to='/register'>
                                    <strong>Register</strong>
                                </Link>
                            </li>
                        </>
                    )
                    : ( <>
                        <div className="btn-group relative">
                            <button type="button" 
                                    className="btn btn-primary" 
                                    style={{borderRadius: "1rem"}}
                                    onClick={toggleMenu}>
                                <small><strong>{user?.user?.username}</strong></small> &nbsp;
                                <Avatar src={user?.user?.gender==="female"?Female:Male} /> &nbsp;
                                <AiFillCaretDown />
                            </button>
                            <div className={`${menu? "" : "d-none"}`} 
                                 style={{
                                        position: "absolute", 
                                        top: "3rem", 
                                        zIndex: "5", 
                                        background: "white", 
                                        width: "100%", 
                                        borderRadius: "1rem"
                                     }}>
                                 <li className="dropdown-item"><Link to="/" onClick={logoutUser} >Logout</Link></li>
                                 <li className="dropdown-item"><Link to="/my-profile" >My Profile</Link></li>
                            </div>
                        </div>
                      </> )
                }
            </ul>
        </div> 
        </nav>
    )
}

export default Navbar
